import { render, staticRenderFns } from "./tag_domain_pin_btn.vue?vue&type=template&id=6454915d&scoped=true&lang=pug&"
import script from "./tag_domain_pin_btn.vue?vue&type=script&lang=js&"
export * from "./tag_domain_pin_btn.vue?vue&type=script&lang=js&"
import style0 from "./tag_domain_pin_btn.vue?vue&type=style&index=0&id=6454915d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454915d",
  null
  
)

export default component.exports